import { QueryClient } from '@tanstack/react-query';

/** A QueryClient tuned for the ledger: conservative retries, no focus-refetch churn. */
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 15_000,
      },
    },
  });
}
